import { LogsInitConfiguration } from "@datadog/browser-logs";
import type { RumInitConfiguration } from "@datadog/browser-rum";
import { config } from "config";

export const rumConfig: RumInitConfiguration = {
  applicationId: config.datadog.applicationId,
  clientToken: config.datadog.clientToken,
  service: "client-sdk",
  sessionSampleRate: 100,
  env: config.appEnv,
  site: "datadoghq.com",
  sessionReplaySampleRate: 100,
  allowedTracingUrls: [
    "https://api.production.boompay.app",
    "https://api.staging.boompay.app",
    "https://api.sandbox.boompay.app"
  ],
  version: config.buildId,
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  defaultPrivacyLevel: "allow"
};

export const logsConfig: LogsInitConfiguration = {
  clientToken: config.datadog.clientToken,
  service: "client-sdk",
  env: config.appEnv,
  forwardErrorsToLogs: true,
  version: config.buildId, // Ensure buildId is defined, fallback to "local" if not set
  forwardConsoleLogs: "all",
  forwardReports: "all",
  sessionSampleRate: 100,
  telemetrySampleRate: 100
};
